<template>
  <div class="mystudio container-fluid">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-astrology">My Studio</h4>
              </div>
            </div>
          </div>
          <!-- <b-card class="p-3"> -->
          <!-- <p class="my-studio-av-p my-0">
              Here are a few things to help you manage your studio.
            </p> -->

          <b-card
            title="My Events"
            tag="article"
            class="card-transparent-background astrology-border-div mb-2"
          >
            <b-row>
              <b-col lg="8" 
                ><b-card-text class="mb-2">
                  Create your online classes
                </b-card-text></b-col
              >
              <b-col lg="4" class="text-right">
                <router-link
                  to="/astrology_ventures/admin/my_studio"
                  class="card-link astrologyLink"
                >
                  Create Event
                  <span class="mx-1 my-auto">
                    <font-awesome-icon
                      icon="fa-sharp fa-solid fa-circle-arrow-right"
                      size="md"
                      class="align-middle link-arrow"
                    />
                  </span> </router-link
              ></b-col>
            </b-row>
          </b-card>

          <b-card
            title="Manage Memberships"
            tag="article"
            class="card-transparent-background astrology-border-div mb-2"
          >
            <b-row>
              <b-col lg="8" md="8">
                <b-card-text class="mb-2">
                  Create and manage memberships and packs
                </b-card-text>
              </b-col>
              <b-col lg="4"  md="4" class="text-right">
                <router-link
                  to="/astrology_ventures/admin/my_studio"
                  class="card-link astrologyLink"
                >
                  Go To Packs
                  <span class="mx-1 my-auto">
                    <font-awesome-icon
                      icon="fa-sharp fa-solid fa-circle-arrow-right"
                      size="md"
                      class="align-middle link-arrow"
                    />
                  </span> </router-link
              ></b-col>
            </b-row>
          </b-card>

          <b-card
            title="Questionnaire"
            tag="article"
            class="card-transparent-background astrology-border-div mb-2"
          >
            <b-row>
              <b-col lg="8" md="8">
                <b-card-text class="mb-2">
                  Manage your app questionnare
                </b-card-text>
              </b-col>
              <b-col lg="4" md="4" class="text-right">
                <router-link
                  to="/astrology_ventures/admin/my_studio/questionnaire"
                  class="card-link astrologyLink"
                >
                  Go To Questionnaire
                  <span class="mx-1 my-auto">
                    <font-awesome-icon
                      icon="fa-sharp fa-solid fa-circle-arrow-right"
                      size="md"
                      class="align-middle link-arrow"
                    />
                  </span> </router-link
              ></b-col>
            </b-row>
          </b-card>

          <!-- <b-card
              title="Upload A Video"
              tag="article"
              class="card-transparent-background astrology-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Upload pre-recorded and live videos
              </b-card-text>

              <router-link
                to="/astrology/video_library"
                class="card-link astrologyLink d-flex "
              >
                Go To Library
                <span class=" mx-1 my-auto"> <font-awesome-icon icon="fa-solid fa-arrow-right" size="md" class="align-middle"  /> </span>
              </router-link>
            </b-card> -->
          <!-- <b-card
              title="Upload Audio"
              tag="article"
              class="card-transparent-background astrology-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Upload audio and video meditations
              </b-card-text>

              <router-link
                to="/astrology/meditation_library"
                class="card-link astrologyLink"
              >
                Go To Library
                <span class=" mx-1 my-auto"> <font-awesome-icon icon="fa-solid fa-arrow-right" size="md" class="align-middle"  /> </span>
              </router-link>
            </b-card> -->
          <!-- <b-card
              title="Upload Music"
              tag="article"
              class="card-transparent-background astrology-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Upload audio from Spotify or as MP3
              </b-card-text>

              <router-link
                to="/astrology/music_library"
                class="card-link astrologyLink"
              >
                Go To Library
                <span class=" mx-1 my-auto"> <font-awesome-icon icon="fa-solid fa-arrow-right" size="md" class="align-middle"  /> </span>
              </router-link>
            </b-card> -->
          <!-- </b-card> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AstrologyMyStudio",
  components: {},
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/astrology_ventures/admin/MyStudio.vue